import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/constitution/edit')({

}).lazy(() => import('./edit.lazy').then((d) => d.Route));
